import { ICallDirection } from '@dataTypes/calls.type'
import { MessageData } from '@dataTypes/message.types'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchCallerData = createAsyncThunk(
  'api/caller/fetch',
  async () => {
    const mockCaller: Partial<MessageData> = {
      channel: 'SMS',
      contact: '(555) 013-7355',
    }
    return mockCaller
  },
)

export const updateCallerData = createAsyncThunk(
  'api/caller/update/data',
  async (caller: Partial<MessageData>) => {
    return caller
  },
)

export const updateCallerType = createAsyncThunk(
  'api/caller/update/type',
  async (type: ICallDirection) => {
    return type
  },
)

export const resetCallerData = createAsyncThunk(
  'api/caller/update/reset',
  async () => {
    return
  },
)
